import HomePage from "../pages/Home/HomePage";
import PurchaseDetails from "../pages/Buy/Details";
import Pay from "../pages/Buy/Pay";
import Result from "../pages/Buy/Result";

const routes = [
  {
    path: "/",
    component: <PurchaseDetails />,
    exact: true,
  },
  {
    path: "/pay",
    component: <Pay />,
    exact: true,
  },
  {
    path: "/result",
    component: <Result />,
    exact: true,
  },
];

export default routes;
